import { render, staticRenderFns } from "./businessPageSkeleton.vue?vue&type=template&id=0c803012&scoped=true"
import script from "./businessPageSkeleton.vue?vue&type=script&lang=js"
export * from "./businessPageSkeleton.vue?vue&type=script&lang=js"
import style0 from "./businessPageSkeleton.vue?vue&type=style&index=0&id=0c803012&prod&scoped=true&lang=css"
import style1 from "./businessPageSkeleton.vue?vue&type=style&index=1&id=0c803012&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c803012",
  null
  
)

export default component.exports